export default __webpack_public_path__ + "static/media/header-d-2.8ddc4dab.png";